import { MessageType } from '@acs-manageability/core'

export default ({ webSocketConnection, broker, promiseResolver }) => {
  return {
    getResources() {
      return new Promise((resolve, reject) => {
        promiseResolver.setPromiseReject(reject)
        promiseResolver.setPromiseResolve(resolve)

        const brokerMessage = broker.getMessage(MessageType.GET_RESOURCES)
        const message = {
          message_type: MessageType.GET_RESOURCES,
          content: brokerMessage,
        }

        webSocketConnection.sendMessage(message)
      })
    },
    allocateResource(resource, usePromise = true) {
      const { id } = resource
      if (usePromise) {
        return new Promise((resolve, reject) => {
          promiseResolver.setPromiseReject(reject)
          promiseResolver.setPromiseResolve(resolve)

          const brokerMessage = broker.getMessage(MessageType.ALLOCATE, resource)
          const message = {
            message_type: MessageType.ALLOCATE,
            to: id,
            content: brokerMessage,
          }

          webSocketConnection.sendMessage(message)
        })
      } else {
        const brokerMessage = broker.getMessage(MessageType.ALLOCATE, resource)
        const message = {
          message_type: MessageType.ALLOCATE,
          to: id,
          content: brokerMessage,
        }

        webSocketConnection.sendMessage(message)
      }
    },
  }
}
